export const portalParentClassName = 'atlaskit-portal-container';
export const portalParentSelector = 'body > .atlaskit-portal-container';
export const portalClassName = 'atlaskit-portal';